import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800&family=Work+Sans:wght@400;500;600;700;800;900&display=swap');

:root {
  --bg-primary: #191F24;
  --bg-secondary: #234048;
  --color-yellow: #FFDA6D;
  --color-white: #FFFFFF;
  --font-raleway: 'Raleway', sans-serif;
  --font-workSans: 'Work Sans', sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-image: url('./image/background.png');
  background-size: cover;
  color: var(--color-white);
  font-family: var(--font-raleway);
}

ul,li,ol {
  list-style: none;
}

button {
  cursor: pointer;
}

a {
 text-decoration: none;
 color: #FFDA6D;
}
`;

export const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0 2rem 2rem 2rem;
 
`;
